export const appWord = "MAa";
export default {appWord};